export default "__VITE_ASSET__5BSXt3Wb__"